export const base64ToFile = async (
  dataUrl: string,
  fileName: string
): Promise<File> => {
  const arr = dataUrl.split(",");
  const mime = arr[0].match(/:(.*?);/)?.[1] || "text/plain";
  const res: Response = await fetch(dataUrl);
  const blob: Blob = await res.blob();

  return new File([blob], fileName, { type: mime });
};
